<template>
  <section>
    <el-dialog :visible.sync="dialogVisible_approve">
      <Approve v-if="dialogVisible_approve" @approve_submit="approve_submit" :SP_IF="SP_IF" :ApproveList="request_list"></Approve>
    </el-dialog>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form class="form_cls" :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent>
      <el-form-item label="" class="input_width_100">
        <el-input :style="isMobile ? 'width: 230px !important;' : ''" v-model="filters.key" placeholder="医院名称/任职机构"></el-input>
      </el-form-item>
      <el-form-item class="input_width_100" label="">
        <el-select :style="isMobile ? 'width: 230px !important;' : ''" v-model="filters.checkStatus" clearable placeholder="本日填报状态">
          <el-option label="待填报" :value="1"></el-option>
          <el-option label="已填报" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item
        v-if="!item.IsHide && (isMobile && item.name == '导出' ? false : true)"
        class="input_width_100"
        v-for="item in buttonList"
        v-bind:key="item.id"
      >
        <!-- 这里触发点击事件 -->
        <el-button
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div v-if="isMobile" class="table_top_div">
      <ExpendListMobile :tabel_list="tabel_list"></ExpendListMobile>
    </div>
    <div v-else>
      <div v-if="SP_IF" style="margin-bottom: 5px">
        <div style="background-color: white; padding: 30px; border-radius: 10px">
          <Approve v-if="SP_IF" :SP_IF="SP_IF" @approve_submit="approve_submit" :ApproveList="tabel_list[0].approvaResultDto"></Approve>
        </div>
      </div>
      <div class="table_top_div" v-for="(item, indexitem) in tabel_list" style="margin-bottom: 5px">
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 5px 0 0 15px; margin-bottom: 10px">
          <div>
            <span style="margin-bottom: 5px; font-size: 18px; font-weight: bold; display: inline-block; color: #6170d7; vertical-align: sub">
              {{ item.details[0].hospitalName }}
            </span>
            <el-button type="primary" style="margin-left: 20px" v-preventReClick="3000" @click="save(item)">提 交</el-button>
          </div>
          <el-tag style="vertical-align: middle" :type="item.isReported ? 'success' : 'danger'">
            {{ item.isReported ? '本日已填报' : '本日未填报' }}
          </el-tag>
        </div>
        <el-table
          border
          max-height="100%"
          :data="item.details"
          :span-method="objectSpanMethod"
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA', padding: ' 8px 0 !important' }"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          header-cell-class-name="header_cell_name"
          @selection-change="selsChange"
          style="width: 100%"
        >
          <el-table-column sortable type="index" label="序号" width="80">
            <template slot-scope="scope">
              {{ indexitem + 1 }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="category" label="Category" width></el-table-column> -->
          <el-table-column prop="productSKU" label="产品编码" width></el-table-column>
          <el-table-column prop="hospitalName" label="医院名称" width></el-table-column>
          <el-table-column prop="indicatorQuota" label="每日指标" width></el-table-column>
          <el-table-column prop="quota" label="上报数量" width>
            <template slot-scope="scope">
              <el-input onkeyup="value=value.replace(/[^\d]/g,'')" v-model="scope.row.quota" class="border_none" placeholder="请填写"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div style="text-align: center; margin-top: 5px"></div> -->
      </div>
      <!--工具条-->
      <!-- <div class="toolbar_div">
          <el-col :span="24" class="toolbar">
            <el-pagination
              :background="true"
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :pageNumber-size="50"
              :total="total"
              style="float: right"
            ></el-pagination>
          </el-col>
        </div> -->
    </div>
    <el-dialog title="导出" :visible.sync="dialogVisible_upload" width="40%">
      <el-form :model="upload_from" label-width="80px" inline>
        <el-form-item label="">
          <el-date-picker v-model="upload_from.startTime" type="date" placeholder="开始日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-date-picker v-model="upload_from.endTime" type="date" placeholder="结束日期"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_upload = false">取 消</el-button>
        <el-button type="primary" @click="uploads()">导 出</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import util from '../../../util/date'
import { expend_getlist, expend_exportdata, expend_submitestimate } from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { uploadfiles } from '@/uploadfiles'
import { quillEditor } from 'vue-quill-editor'
import ExpendListMobile from './mobile/ExpendListMobile'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
import Toolbar from '../../components/Toolbar'
import Approve from '../../components/Approve'

export default {
  components: { Toolbar, quillEditor, Approve, ExpendListMobile },
  data() {
    return {
      upload_from: {},
      dialogVisible_approve: false,
      dialogVisible_upload: false,
      SP_IF: '',
      isMobile: false,
      request_list: [],
      description_text: '',
      rolename_if: false,
      num_zt: 0,
      tableHeight: 0,
      buttonList: [],
      editorOption: {
        // editorOption里是放图片上传配置参数用的，例如：
        action: '/images/Upload/Pic', // 必填参数 图片上传地址
        methods: 'post', // 必填参数 图片上传方式
        token: this.token, // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        // name: 'upload_file',  // 必填参数 文件的参数名
        // size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
        // accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon,image/jpg'  // 可选 可上传的图片格式
      },
      token: '',
      addLoading: false,
      editFormRules: {
        html: [{ required: true, message: '请填写', trigger: 'blur' }],
        type: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      currentRow: null,
      filters: {
        pageSize: 200,
      },
      tabel_list: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      pageNumber: 1,
      listLoading: false,
      sels: [], //列表选中列
    }
  },
  methods: {
    async save(res) {
      const { data } = await expend_submitestimate(res)
      if (data.code == 200) {
        this.$message.success(data.msg)
      } else {
        this.$message.error(data.msg)
      }
    },
    async uploads() {
      let para = this.upload_from
      if (!para.endTime || !para.startTime) {
        this.$message.error('请选择开始时间和结束时间')
        return
      }
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        // spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const { data, headers } = await expend_exportdata(para)
      uploadfiles(data, headers, this.loading)
    },
    async ExportAccount() {
      this.dialogVisible_upload = true
    },
    open_approve(res) {
      this.request_list = res
      this.dialogVisible_approve = true
      console.log(this.request_list)
    },
    async approve_submit(res) {
      if (res.CH_IF) {
        var { data } = await cataractnnvmp_approvalcancel(res)
      } else {
        var { data } = await cataractnnvmp_approvalclaim(res)
      }
      if (data.code == 200) {
        this.$message.success(data.msg)
      } else {
        this.$message.error(data.msg)
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 17 === 0) {
          return {
            rowspan: 17,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    // callFunction(item) {
    //   this.filters = {
    //     name: item.search,
    //   };
    //   this[item.Func].apply(this, item);
    // },
    handleCurrentChange(val) {
      this.pageNumber = val
      this.getModules()
    },
    getModules_search() {
      this.pageNumber = 1
      this.getModules()
    },
    // 合并数据
    mergeData(data) {
      //   let spanArr = []
      //   let concatSpanArr = []
      let merge = {}
      data.map((item, index) => {
        merge = {
          all_potential: item.potential,
          dip: item.dip,
          drg: item.drg,
        }
        item.details.map((item2, index2) => {
          item2 = { ...item2, ...merge }
          item.details[index2] = item2
        })
      })
      return data
      //   console.log(data)
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.pageNumber = this.pageNumber
      console.log(para)
      // return
      //   let para = {
      //     pageNumber: this.pageNumber,
      //     key: this.filters.key
      //   };
      this.listLoading = true
      expend_getlist(para).then((res) => {
        this.total = res.data.data.dataCount
        // if (res.data.data.data.length == 0) {
        //   this.tabel_list_if = true
        // }
        this.tabel_list = res.data.data.data
        this.listLoading = false
        this.SP_IF = this.$route.query.status
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - 250
    })
    if (window.innerWidth <= 767) {
      this.isMobile = true
      this.collapsedClass = 'menu-collapsed'
      //   this.SidebarVisible = false
    }
    this.getModules()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)
  },
}
</script>

<style></style>
